import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type OpcaoEmpregador = Readonly<{
  id: string
  name: string
  code?: string | null
  visivel?: boolean | null
  id_repp?: string | null
  jurisdicao?: string | null
  tradingName?: string | null
  cpf?: string | null
  cnpj?: string | null
  numeroIdentificador?: string | null
  numeroIdentificadorTipo?: string | null
  ceiCnoCaepf?: string | null
  totalOfEmployees?: number | null
  comp_man?: string | null
}>

export type FiltrosCatalogoEmpregador = Readonly<{
  id?: readonly string[]
  visivel?: boolean
  jurisdicao?: readonly string[]
}>

export type SelecaoCatalogoEmpregador =
  | OpcaoEmpregador
  | readonly OpcaoEmpregador[]
  | null

export type OperacoesCatalogoEmpregador = Readonly<{
  listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoEmpregador[]>
}>

const CAMPOS_PROJECAO = new Set(['id', 'name', 'code', 'visivel', 'id_repp', 'jurisdicao', 'tradingName', 'cpf', 'cnpj', 'numeroIdentificador', 'numeroIdentificadorTipo', 'ceiCnoCaepf', 'totalOfEmployees', 'comp_man'])

export const DESCRITOR_CATALOGO_EMPREGADOR: CatalogoDescriptor<OpcaoEmpregador> = Object.freeze({
  nome: 'empregadores',
  versaoProjecao: 2,
  validarItens: (valor: unknown): valor is readonly OpcaoEmpregador[] => (
    Array.isArray(valor) && valor.every((item: unknown) => typeof item === 'object' && item !== null && !Array.isArray(item)
      && Object.keys(item).every(campo => CAMPOS_PROJECAO.has(campo)))
  ),
})
